var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button } from "semantic-ui-react";
var ChangeVariantVisibilityModal = /** @class */ (function (_super) {
    __extends(ChangeVariantVisibilityModal, _super);
    function ChangeVariantVisibilityModal(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            if (_this.props.admin) {
                _this.props.postRequest("/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) + "/probe-set-families/id/" + encodeURIComponent(_this.props.psfId.toString()) + "/variants/id/" + encodeURIComponent(_this.props.variantId.toString()) + "/visibility/admin", {
                    visible: _this.props.targetVisibility
                });
            }
            else {
                _this.props.postRequest("/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) + "/probe-set-families/id/" + encodeURIComponent(_this.props.psfId.toString()) + "/variants/id/" + encodeURIComponent(_this.props.variantId.toString()) + "/visibility/consumer", {
                    visible: _this.props.targetVisibility
                });
            }
        };
        return _this;
    }
    ChangeVariantVisibilityModal.prototype.render = function () {
        var visibility = this.props.targetVisibility ? 'visible' : 'invisible';
        return React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Are you sure you want to change the visibility for entry ",
                this.props.variantId,
                " to ",
                React.createElement("strong", null, visibility)),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: this.props.targetVisibility ? 'eye' : 'eye slash', label: "Make " + visibility, labelPosition: 'left', onClick: this.submit, positive: this.props.targetVisibility, negative: !this.props.targetVisibility }));
    };
    return ChangeVariantVisibilityModal;
}(React.PureComponent));
export default ChangeVariantVisibilityModal;
//# sourceMappingURL=ChangeVariantVisibilityModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ChangeVariantVisibilityModal.js
// module id = 1463
// module chunks = 0